import React, { PropTypes } from 'react';
import Autocomplete from 'components/places/autocomplete';
import PlaceMultiselect from 'components/places/placeMultiselect';
import TextMultiselect from 'components/multiselect/text';
import { replaceUnicode } from 'utils/emojify';

class DayEditor extends React.Component {

    constructor(props) {
        super(props);
        var self = this;

        self.state = {
            date: self.props.day.date || null,
            dayType: self.props.day.dayType || '',
            airports: self.props.day.airports || null,
            destinations: self.props.day.destinations || null,
            lodging: self.props.day.lodging || null,
            activities: self.props.day.activities || null
        };
    }

    invokeChangeHandler = () => {
        var self = this;

        if (self.props.onChange != null && typeof self.props.onChange === 'function') {
            self.props.onChange(self.state);
        }
    }

    onValueChanged = (change, e) => {
        var self = this;

        e && e.preventDefault();

        self.setState(change, () => {
            self.invokeChangeHandler();
        });
    }

    render () {
        var self = this,
            day = self.props.day || {};

        return (
            <li className="day-editor">
                <h5>{ day.date }</h5>

                <div className="form-group">
                    <label>Day Type</label>

                    <input type="text" className="form-control" placeholder="ex. Travel Day"
                           defaultValue={ day.dayType }
                           onChange={ (e) => self.onValueChanged({ dayType: replaceUnicode(e.target.value) }, e)} />
                </div>

                <div className="form-group">
                    <label>Airports</label>

                    <TextMultiselect placeholder="ex. MDW" 
                                     defaultValues={ day.airports }
                                     onChange={ airports => self.onValueChanged({ airports }) } />
                </div>

                <div className="form-group">
                    <label>Destinations</label>

                    <PlaceMultiselect placeholder="ex. Auckland"
                                      defaultPlaces={ day.destinations }
                                      onChange={ destinations => self.onValueChanged({ destinations }) } />
                </div>

                <div className="form-group">
                    <label>Lodging</label>

                    <Autocomplete placeholder="ex. Haka Lodge Auckland"
                                  defaultPlace={ day.lodging }
                                  onChange={ lodging => self.onValueChanged({ lodging }) } />
                </div>

                <div className="form-group">
                    <label>Activities</label>

                    <PlaceMultiselect placeholder="ex. Golden Gate Bridge"
                                      restrictToCities={ false }
                                      defaultPlaces={ day.activities }
                                      onChange={ activities => self.onValueChanged({ activities }) } />
                </div>
            </li>
        );
    }
};

export default DayEditor;


// WEBPACK FOOTER //
// ./src/app/components/editor/dayEditor.jsx